import { Subject } from 'rxjs'

const _closeCaseManagementDialog$ = new Subject<void>()
export const closeManagementDialog$ = _closeCaseManagementDialog$.asObservable()

const _openCaseManagementDialog$ = new Subject<void>()
export const openManagementDialog$ = _openCaseManagementDialog$.asObservable()

export const openCaseManagementDialog = (): void => {
    _openCaseManagementDialog$.next()
}

export const closeCaseManagementDialog = (): void => {
    _closeCaseManagementDialog$.next()
}
